import * as React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */

const Crown = (props) => (
    <svg
        fill='none'
        height='28'
        viewBox='0 0 32 28'
        width='32'
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <path
            d='M15.0803 7.38736C15.5684 6.8992 16.3599 6.8992 16.848 7.38736L20.848 11.3874C21.3362 11.8755 21.3362 12.667 20.848 13.1551L16.848 17.1551C16.3599 17.6433 15.5684 17.6433 15.0803 17.1551L11.0803 13.1551C10.5921 12.667 10.5921 11.8755 11.0803 11.3874L15.0803 7.38736ZM13.7319 12.2712L15.9642 14.5035L18.1964 12.2712L15.9642 10.039L13.7319 12.2712Z'
            fill='currentColor'/>
        <path
            d='M14.55 0.585786C15.331 -0.195261 16.5974 -0.195264 17.3784 0.585786L24.5183 7.72564L29.0246 5.45387C30.57 4.67479 32.3083 6.09319 31.8551 7.76347L27.9641 22.1045V24.6879C27.9641 26.4828 26.5091 27.9379 24.7141 27.9379H7.21414C5.41922 27.9379 3.96414 26.4828 3.96414 24.6879V22.1045L0.0731701 7.76347C-0.380006 6.0932 1.35832 4.67479 2.90371 5.45388L7.41008 7.72568L14.55 0.585786ZM8.53856 10.1327C8.15703 10.5143 7.57376 10.6079 7.09197 10.365L2.77955 8.191L6.23803 20.938H25.6902L29.1487 8.19099L24.8364 10.365C24.3546 10.6079 23.7713 10.5142 23.3898 10.1327L15.9642 2.70711L8.53856 10.1327ZM25.4641 23.438H6.46414V24.6879C6.46414 25.1021 6.79993 25.4379 7.21414 25.4379H24.7141C25.1284 25.4379 25.4641 25.1021 25.4641 24.6879V23.438Z'
            fill='currentColor'/>
    </svg>
);

export default Crown;
